// Safe math expression evaluator using mathjs
import { evaluate } from 'mathjs';

// a variable for all the allowed characters and use regex to match the allowed characters
export const allowedCharacters = /^[0-9.+*/\-()^sqrt%modabsminmax,\s]+$/;
// Operators that indicate a mathematical expression (not unary minus at start)
// This regex looks for operators that are actual operations between values
const hasOperator = /[+*/^%]|sqrt|mod|abs|min|max|(?<!\S)-[0-9]/;
// check if the expression contains only the allowed characters
export const shouldEvaluate = (expression) => {
  if (typeof expression !== 'string' || !expression.trim()) return false;
  // Must contain only allowed characters AND have at least one operator
  if (!allowedCharacters.test(expression)) return false;
  // Check for binary operators (not unary minus at start)
  // A real operator is either: +, *, /, ^, %, or functions, or - between two operands
  const trimmed = expression.trim();
  // If it's just a negative number (starts with - and then only digits), it's not an operation
  if (/^-?[0-9.]+\s*$/.test(trimmed)) return false;
  // Check for actual operators: +, *, /, ^, %, sqrt, mod, abs, min, max, or subtraction between operands
  return /[+*/^%]|sqrt|mod|abs|min|max|\d\s*-\s*\d/.test(expression);
};
export const evaluateExpression = (expression) => {
  try {
   
    // Validate input type
    if (typeof expression !== 'string' || !expression.trim()) return null;

     //remove all spaces from the expression
     expression = expression.replace(/\s/g, '');

    // Only evaluate if expression contains operators (not single numbers)
    if (!shouldEvaluate(expression)) return null;

    const result = evaluate(expression);

    // mathjs can return non-numeric values (e.g. objects, complex numbers)
    if (typeof result !== 'number' || isNaN(result)) return null;


    // Round to 2 decimal places only if the result has decimal places
    return Number.isInteger(result) ? result : Math.round(result * 100) / 100;
  } catch (e) {
    // If expression is invalid or causes an error
    return null;
  }
};
